"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditCompanyAssetGalleryModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const Api = __importStar(require("@src/api"));
const AssetLibrary_1 = require("@src/components/modules/AssetLibrary");
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const styled_components_1 = __importDefault(require("styled-components"));
const EditCompanyAssetGalleryModal = ({ assetGalleryToEdit, selectedAssetGalleryAssetIds, setAssetGalleryToEdit, }) => {
    const assetGalleryRef = react_1.default.useRef(null);
    const [titleValue, setTitleValue] = react_1.default.useState('');
    const intl = (0, react_intl_1.useIntl)();
    const { invalidateSSRContext } = (0, useSSRFetch_1.useSSRFetchClient)();
    const { mutateAsync: updateCompanyAssetGallery } = (0, useAppMutation_1.useAppMutation)(Api.CompanyAssetGallery.updateCompanyAssetGallery, {
        onSuccess: () => {
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'general.warning',
                }),
                description: intl.formatMessage({
                    id: 'general.successfuly_saved',
                }),
            });
        },
    });
    const onSubmit = async () => {
        var _a;
        try {
            const assetIds = (_a = assetGalleryRef.current) === null || _a === void 0 ? void 0 : _a.getSelectedAssets().map(({ id }) => id);
            if (assetGalleryToEdit && assetIds && assetIds.length) {
                await updateCompanyAssetGallery({
                    galleryTitle: titleValue,
                    galleryId: assetGalleryToEdit.id,
                    assetIds,
                });
                invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.companyProfile.key);
                setAssetGalleryToEdit(null);
                return;
            }
            antd_1.notification.warning({
                message: intl.formatMessage({
                    id: 'admin.company_premium_profile.no_file_selected',
                }),
                description: intl.formatMessage({
                    id: 'admin.company_premium_profile.choose_at_least_one_file_gallery',
                }),
            });
        }
        catch (err) {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({ id: 'general.error' }),
                description: intl.formatMessage({ id: 'general.something_went_wrong' }),
            });
        }
    };
    react_1.default.useEffect(() => {
        if (assetGalleryRef.current) {
            assetGalleryRef.current.setSelectedAssetIds(selectedAssetGalleryAssetIds);
        }
    }, [selectedAssetGalleryAssetIds]);
    react_1.default.useEffect(() => {
        setTitleValue((assetGalleryToEdit === null || assetGalleryToEdit === void 0 ? void 0 : assetGalleryToEdit.title) || '');
    }, [assetGalleryToEdit]);
    return ((0, jsx_runtime_1.jsxs)(EditAssetsModal, { title: (0, jsx_runtime_1.jsxs)("div", { className: "flex-row justify-space-between gap-m align-center", children: [(0, jsx_runtime_1.jsx)("div", { children: intl.formatMessage({
                        id: 'admin.company_premium_profile.edit_gallery',
                    }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-row gap-m", children: [(0, jsx_runtime_1.jsx)(elements_1.Button, { type: "default", size: "middle", onClick: () => setAssetGalleryToEdit(null), children: intl.formatMessage({ id: 'general.cancel' }) }), (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "middle", onClick: () => onSubmit(), children: intl.formatMessage({ id: 'general.save' }) })] })] }), visible: Boolean(assetGalleryToEdit), forceRender: true, footer: null, children: [(0, jsx_runtime_1.jsxs)("div", { className: "m-b-l", children: [(0, jsx_runtime_1.jsx)("div", { className: "m-b-xs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.company_premium_profile.gallery_name" }) }), (0, jsx_runtime_1.jsx)(elements_1.Input, { value: titleValue, onChange: e => setTitleValue(e.target.value), placeholder: intl.formatMessage({
                            id: 'admin.company_premium_profile.gallery_name_placeholder',
                        }), maxLength: 100 })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "m-b-xs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.company_premium_profile.media" }) }), (0, jsx_runtime_1.jsx)(AssetLibrary_1.AssetLibrary, { ref: assetGalleryRef, areDocumentsDisabled: true, isInSelectMode: true, showSelectedAssetOrder: true })] })] }));
};
exports.EditCompanyAssetGalleryModal = EditCompanyAssetGalleryModal;
const EditAssetsModal = (0, styled_components_1.default)(elements_1.Modal) `
	width: 100vw !important;
	max-width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	margin: 0;
	border-radius: 0;
	padding: 0;

	.ant-modal-close {
		display: none;
	}

	.ant-modal-header {
		position: sticky;
		border-radius: 0;
		position: 0;
		top: 0;
		z-index: 3;
	}
	.ant-modal-body {
		border-radius: 0;
	}
	.ant-modal-content {
		height: 100%;
	}
`;
